import { TableCell, TableRow } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { TableVirtuoso } from "react-virtuoso";
import { RootState } from "../../../redux/store";
import { IPaymentTable } from "../../../interfaces/payment/material/IPaymentTable";

export const PaymentTable = ({
  featuresComponents,
  stickyTitle,
  height,
  className,
}: IPaymentTable) => {
  const componentColors = useSelector(
    (state: RootState) => state.theme.componentColors
  );

  return (
    <TableVirtuoso
      className={`w-full scrollbar-hide mb-[40px] lg:mb-0 ${
        className ?? className
      }  overflow-y-hidden`}
      style={{
        backgroundColor: componentColors.surface.surfContainer,
        height: `${height}`,
      }}
      components={{
        Table: ({ style, ...props }) => (
          <table {...props} style={{ ...style }} className="w-full" />
        ),
      }}
      fixedHeaderContent={() => (
        <TableRow>
          <TableCell
            className="font-medium"
            style={{
              width: 150,
              position: "sticky",
              left: 0,
              zIndex: 1,
              backgroundColor: componentColors.surface.surfContainer,
              color: componentColors.surface.onSurface,
            }}
          >
            {stickyTitle}
          </TableCell>
          <TableCell
            className="font-medium"
            sx={{
              backgroundColor: componentColors.surface.surfContainer,
              color: componentColors.surface.onSurface,
            }}
          >
            Free
          </TableCell>
          <TableCell
            className="font-medium"
            sx={{
              backgroundColor: componentColors.surface.surfContainer,
              color: componentColors.surface.onSurface,
            }}
          >
            Bronze
          </TableCell>
          <TableCell
            className="font-medium"
            sx={{
              backgroundColor: componentColors.surface.surfContainer,
              color: componentColors.surface.onSurface,
            }}
          >
            Silver
          </TableCell>
          <TableCell
            className="font-medium"
            sx={{
              backgroundColor: componentColors.surface.surfContainer,
              color: componentColors.surface.onSurface,
            }}
          >
            Gold
          </TableCell>
        </TableRow>
      )}
      itemContent={(index, item) => {
        return (
          <>
            <TableCell
              sx={{
                width: 150,
                position: "sticky",
                left: 0,
                backgroundColor: componentColors.surface.surfContainer,
                color: componentColors.surface.onSurface,
              }}
            >
              {item.title}
            </TableCell>
            {item.content.map((item, i) => {
              return (
                <TableCell
                  sx={{
                    color: componentColors.surface.onSurface,
                    backgroundColor: componentColors.surface.surfContainer,
                  }}
                  key={i}
                >
                  {item}
                </TableCell>
              );
            })}
          </>
        );
      }}
      data={featuresComponents}
    />
  );
};
